<dialog
  class="overlay-popover"
  closedby="any"
  [open]="isOpen()"
  (close)="emitClose()"
>
  <ng-content></ng-content>
</dialog>
